import { QTypography } from '@kw/quokka-ui';

export const getUnenrollDeviceOwnerExtraDetails = () => (
  <div>
    <QTypography variant="bodyBold">What to expect when you unenroll a Device Owner:</QTypography>
    <QTypography variant="bodyRegular">
      <ul style={{ paddingLeft: '16px', marginTop: '8px', marginBottom: '8px' }}>
        <li>All devices enrolled by that Device Owner will be unenrolled from your organization and removed from the Devices page</li>
        <li>Any Managed Apps the Device Owner has installed on their enrolled devices will be revoked</li>
        <li>Any pending re-invite emails still active will be invalidated</li>
        <li>The Device Owner will be moved from the Enrolled tab to the Unenrolled tab</li>
        <li>The Device Owner will require another Invite from the Unenrolled tab to re-join the organization</li>
      </ul>
    </QTypography>
  </div>
);
